import { Flex } from '@chakra-ui/react'
import React from 'react'
import { TrackedParkingLot } from '~/atoms/WebphoneState'
import { PresenceState } from '~/utils/xml'

import { ParkTarget } from './ParkTarget'

interface ParkControlProps {
  parkingLots: TrackedParkingLot[]
  onParkCall: (parkExtension: string) => void
}
export const ParkControl = ({ parkingLots, onParkCall }: ParkControlProps) => {
  return (
    <Flex direction="column" w="100%" paddingBottom="12px">
      {parkingLots.map((parkingExtension) => {
        return (
          <Flex direction="column" w="100%" key={parkingExtension.id}>
            <ParkTarget
              key={parkingExtension.id}
              parkName={parkingExtension.label}
              parkExtension={parkingExtension.targetNumber}
              presence={parkingExtension.presence ?? PresenceState.Unknown}
              onPark={onParkCall}
            />
          </Flex>
        )
      })}
    </Flex>
  )
}
